import { DatasetDataInfoResponse } from "api/model/dataset/DatasetDataInfoResponse";
import React from "react";
import { T } from "services/lang/LanguageService";
import { TimeOptions, TimeOptionKeys } from "components/basic/dropdowns/time-unit-dropdown/timeUnits";
import { DataTable } from "primereact/datatable";
import { useTimezone } from "hooks/useTimezone";
import { WeatherComponentDatasetProps, WeatherMonitoringProps } from "../charts/interfaces";
import generateColumns from "./GenerateWeatherMonitoringColumns";
import DatasetLineChart from "../charts/dataset-line-chart/DatasetLineChart";
import { getVisibleDatasets } from "./WeatherMonitoringUtils";

const ChartPanel = ({
  datasetsData,
  currentChartData,
  timeInterval,
  startTime,
  endTime,
  isChartVisible,
  reportMode,
}: {
  datasetsData: DatasetDataInfoResponse[];
  currentChartData: WeatherMonitoringProps;
  timeInterval: TimeOptionKeys;
  startTime: Date;
  endTime: Date;
  isChartVisible: boolean;
  reportMode: boolean;
}) => {
  const tz = useTimezone();

  return (
    <div className="overflow-x-auto w-max pr-2">
      {isChartVisible && (
        <div>
          <div className="flex flex-row gap-1">
            <div className="flex flex-column gap-2" style={{ marginTop: "2.8rem" }}>
              <div>{T("word-short.temperature")}</div>
              <div>{T("word-short.humidity")}</div>
              <div>{T("word-short.precipitation")}</div>
              <div>{T("word.wind")}</div>
              <div>{T("word-short.direction")}</div>
            </div>
            {datasetsData && (
              <DataTable value={[{ id: 1 }]} showGridlines size="small">
                {generateColumns(datasetsData, currentChartData, timeInterval, startTime, tz)}
              </DataTable>
            )}
          </div>
          {((currentChartData.temperature?.isVisible && currentChartData.temperature.dataset) ||
            (currentChartData.feelsLikeTemperature?.isVisible &&
              currentChartData.feelsLikeTemperature.dataset)) && (
            <DatasetLineChart
              datasets={getVisibleDatasets(
                ...([currentChartData.temperature, currentChartData.feelsLikeTemperature].filter(
                  Boolean
                ) as WeatherComponentDatasetProps[])
              )}
              height={150}
              reportMode={reportMode}
              dateFrom={startTime}
              dateTo={endTime}
              hideRefresh
              timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
              title=""
            />
          )}
          {currentChartData.humidity?.isVisible && currentChartData.humidity.dataset && (
            <DatasetLineChart
              datasets={getVisibleDatasets(currentChartData.humidity)}
              height={150}
              reportMode={reportMode}
              dateFrom={startTime}
              dateTo={endTime}
              hideRefresh
              timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
              title=""
            />
          )}
          {((currentChartData.windSpeed?.isVisible && currentChartData.windSpeed.dataset) ||
            (currentChartData.gusture?.isVisible && currentChartData.gusture.dataset)) && (
            <DatasetLineChart
              datasets={getVisibleDatasets(
                ...([currentChartData.windSpeed, currentChartData.gusture].filter(
                  Boolean
                ) as WeatherComponentDatasetProps[])
              )}
              height={150}
              reportMode={reportMode}
              dateFrom={startTime}
              dateTo={endTime}
              hideRefresh
              timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
              title=""
            />
          )}
          {currentChartData.precipitation?.isVisible && currentChartData.precipitation.dataset && (
            <DatasetLineChart
              datasets={getVisibleDatasets(currentChartData.precipitation)}
              height={150}
              reportMode={reportMode}
              dateFrom={startTime}
              dateTo={endTime}
              hideRefresh
              timeAxisStepSeconds={TimeOptions[timeInterval].duration.seconds()}
              title=""
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ChartPanel;
